import React, { useEffect, useState } from "react";
import Turnstile, { useTurnstile } from "react-turnstile";
import {
  Container,
  Form,
  Button,
  Card,
  Navbar,
  Image,
  Spinner,
} from "react-bootstrap";

import { Link, useHistory } from "react-router-dom";
import Logo from "../../beatai-logo.svg";
import { ToastContainer, toast } from "react-toastify";
import { IS_DEV, requestPasswordReset } from "../../service/api";

const ForgotPassword = () => {
  const turnstile = useTurnstile();
  const [CFToken, setCFToken] = useState("");
  const [errorText, setErrorText] = useState("");
  const successSent = () => {
    toast("Link is sent to provided email!", {
      position: "top-right",
    });
  };
  useEffect(() => {
    document.title = "BeatAI - Forgot Password";
  }, []);
  const [email, setEmail] = useState("");
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    requestPasswordReset(email, CFToken)
      .then(async (r) => {
        const d = await r.json();
        if ("captcha" in d) {
          setErrorText("Captcha invalid!");
          setIsLoading(false);
          setTimeout(() => {
            setErrorText("");
          }, 5000);
          return;
        }
        successSent();
        setTimeout(() => {
          history.push("/login?sc=ef5199c2-e6b8-4257-9932-20aa6f449c90R");
        }, 3000);
        setIsLoading(false);
      })
      .catch((e) => {
        setErrorText("Technical error sending mail to provided email!");
        setIsLoading(false);
      });
  };

  return (
    <>
      <Navbar
        sticky="top"
        bg="dark"
        variant="dark"
        expand="lg"
        className="w-100 m-0 nav_"
      >
        <Container fluid className="px-3">
          <Navbar.Brand className="ms-2">
            <Image src={Logo} style={{ maxWidth: "140px" }} />
          </Navbar.Brand>
        </Container>
      </Navbar>
      <Container className="d-flex align-items-center justify-content-center vh-100">
        <Card
          className="border-card-purp dark-theme p-4 auth-card"
          style={{ width: "400px" }}
        >
          <Card.Body>
            <h2 className="text-center mb-4">Forgot Password</h2>
            <p className="text-center mb-4">
              Enter your email address to receive a password reset link
            </p>
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className=""
                  placeholder="Email to receive reset link"
                  required
                />
              </Form.Group>
              <Turnstile
                className="turnsite"
                sitekey={
                  IS_DEV
                    ? "1x00000000000000000000AA"
                    : "0x4AAAAAAA29TKraRXtvC8Rg"
                }
                size="flexible"
                theme="dark"
                style={{
                  marginBottom: "10px",
                }}
                onVerify={(token) => {
                  setCFToken(token);
                }}
              />
              <p className="text-danger">{errorText}</p>

              <Button
                disabled={isLoading}
                className={"beat-btn-pr w-100"}
                variant="primary"
                type="submit"
              >
                {isLoading ? <Spinner size="sm" /> : "Send Reset Link"}
              </Button>
            </Form>
            <div className="text-center mt-3 link-a">
              <Link to="/login?sc=ef5199c2-e6b8-4257-9932-20aa6f449c90R">
                Back to Login
              </Link>
            </div>
          </Card.Body>
        </Card>
        <ToastContainer />
      </Container>
    </>
  );
};

export default ForgotPassword;
